import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../../library/layout/Index";

const ItemTechViewer = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)
        
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Advance Configuration' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} id="editbtnh1" ksc="c" rowKey="" starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>

                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pricingMode" }} value="Pricing Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "pricingMode" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "childGranularity" }} value="Inventory Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "childGranularity" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inventoryMode" }} value="Inventory Control" />
                                </span>
                                <span className="uiVal" id="svInventoryMode" ></span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "inventoryMode" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} value="Track Inventory" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isMarketDriven" }} value="Market Driven Price" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isMarketDriven" }} className="uiVal" />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isMake" }} value="Can Make" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isMake" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isSell" }} value="Can Sell" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isSell" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isExpire" }} value="Can Expire" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isExpire" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isService" }} value="Is Service" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isService" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isConsign" }} value="Is Consignment" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isConsign" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isAsset" }} value="Is Asset" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isAsset" }} className="uiVal" />
                            </li>
                            <li>
                                <div id="svReviewStatus" >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reviewStatus" }} value="Review Status" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reviewStatus" }} className="uiVal" />
                                </div>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} value="Document Status" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} className="uiDocumentStatus" />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ItemTechViewer, "itemTech", "");